<div class="header-actions">
    <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
            <svg>
                <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
            </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
    </button>
</div>

<h2 [innerHtml]="'popins.share.title' | translate"></h2>
<img src="{{image}}"/>
<p>{{ 'popins.share.description' | translate }}</p>
<div class="input-group">
    <input type="text" id="copyTarget" class="form-control" [value]="linkUrl" readonly>
    <span class="copy-btn" (click)="copyToClipboard()">
        <strong>{{ 'popins.share.copy' | translate }}</strong>
    </span>
</div>
<!-- <span *ngIf="copied" class="copied">{{ 'popins.share.copied' | translate }}</span> -->
<span *ngIf="copied" class="copied" [ngClass]="{'floating-copied': copied}">{{ 'popins.share.copied' | translate }}</span>
